import React from "react";
import { PageBanner } from "../components/common";
import About from "../sections/About";
import WhoWeAre from "../sections/WhoWeAre";
import Stats from "../sections/Stats";
import Team from "../sections/Team";
import Testimonials from "../sections/Testimonials";
import RunningMarquee from "../sections/RunningMarquee";

const AboutPage = () => {
  return (
    <main>
      <PageBanner
        title="About Us"
        crumb="About"
        image="https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
      />
      <About />
      <Stats />
      <WhoWeAre />
      <RunningMarquee text="Family run · Trading since 1965 · Cambridgeshire" />
      <Team />
      <Testimonials />
    </main>
  );
};

export default AboutPage;
